export enum OperatingSystem {
  Ios = 'ios',
  Android = 'android',
  Windows = 'windows',
  Mac = 'mac',
  Unknown = 'unknown',
}

export enum Platform {
  Ios = 'ios',
  Android = 'android',
  Web = 'web',
}
